export const educationData = [
    {
        id: 1,
        institution: 'VISION 40',
        course: 'Higher Secondary Education',
        startYear: '2016',
        endYear: '2018'
    },
    {
        id: 2,
        institution: 'Malla Reddy College of Engineering',
        course: 'Bachelor of Technology',
        startYear: '2018',
        endYear: '2022'
    },
    // {
    //     id: 3,
    //     institution: 'Hawking University, Cambridge',
    //     course: 'Master of Technology',
    //     startYear: '2019',
    //     endYear: 'Present'
    // },
]